import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { prepareHeadersWithAuthorization as prepareHeaders } from '@/apis/headers';
import { Outage } from '@/apis/outages/types/outagesApi';
import {
  outageFromApiAdapter,
  outagesFromApiAdapter,
} from '@/apis/outages/adapters/outagesFromApiAdapter';

import { PaginatedResponse } from '@/types';

const BASE_URL = import.meta.env.VITE_APP_API_URL;

export interface OutagesParams {
  siteId?: number | null;
  startDate?: string | null;
  endDate?: string | null;
  search?: string | null;
  limit?: number;
  offset?: number;
  orderBy?: string;
  sortDir?: 'asc' | 'desc';
}

export const outagesApi = createApi({
  reducerPath: 'outagesApi',
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL, prepareHeaders }),
  endpoints: (builder) => ({
    getOutages: builder.query<PaginatedResponse<Outage>, OutagesParams>({
      query: ({
        siteId,
        startDate,
        endDate,
        search,
        limit,
        offset,
        orderBy,
        sortDir,
      }) => ({
        url: '/outages',
        params: {
          ...(siteId && { site_id: siteId }),
          ...(startDate && { start_date: startDate }),
          ...(endDate && { end_date: endDate }),
          ...(search && { search }),
          ...(limit && { limit }),
          ...(offset && { offset }),
          ...(orderBy && { order_by: orderBy }),
          ...(sortDir && { sort_dir: sortDir }),
        },
      }),
      transformResponse: outagesFromApiAdapter,
    }),
    getOutageById: builder.query<Outage, number>({
      query: (outageId) => ({
        url: `/outages/${outageId}`,
      }),
      transformResponse: outageFromApiAdapter,
    }),
  }),
});

export const { useGetOutagesQuery, useGetOutageByIdQuery } = outagesApi;
